import { AuthFrame } from '../components/auth-frame';
import {
  GoogleCallbackCard,
  type GoogleCallbackCardProps,
} from '../components/google-callback-card';

export type GoogleCallbackPageProps = GoogleCallbackCardProps;

export function GoogleCallbackPage(props: GoogleCallbackPageProps) {
  return (
    <AuthFrame>
      <GoogleCallbackCard {...props} />
    </AuthFrame>
  );
}
